export const CONCEPT_TYPE = {
  ALL_UL: "allUl",
  TERM: "term_concept",
};

export type ConceptType = (typeof CONCEPT_TYPE)[keyof typeof CONCEPT_TYPE];
